<template>
  <div>
    <el-dialog v-if="transferDialogVisible" class="addsub-dialog" :visible.sync="transferDialogVisible"
      :close-on-click-modal="false" :title="title" :before-close="handleCloseDialog" style="padding-top: 0px;">
      <div class="addsub-top">
        <el-form :model="transferSelData" :inline="true" :rules="dataRules" ref="transferSel" label-width="150px" label-position="right">
          <div>
            <el-form-item v-if="type !== 'TOB'" label="所属TOG环境：" prop="togSystem">
              <el-select class="w200" v-model="transferSelData.togSystem" :disabled="togSysDisabled" placeholder="请选择TOG系统" @change="togSystemChange">
                  <el-option v-for="item in togSystems" :key="item.appId" :label="item.title" :value="item.appId"></el-option>
              </el-select>
              <span class="ml20" style="color: red;">提示：添加主体前，请先选择对应的TOG环境！</span>
            </el-form-item>
          </div>
          <!-- <el-form-item label="功能集配置" prop="funcCollection">
            <el-select class="w200" v-model="transferSelData.funcCollection" placeholder="请选择功能集类型" @change="funcCollectionChange">
                <el-option v-for="item in funcCollections" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <span v-if="type === 'TOB'" class="ml20" style="color: red;">提示：添加主体前，请先选择被添加主体在校餐卫士系统中的功能集类型！</span>
          </el-form-item> -->
          <el-form-item v-if="type !== 'TOB'" label="主体类型：" prop="togSubType">
            <el-select class="w200" v-model="transferSelData.togSubType" placeholder="请选择主体类型" @change="togSubTypeChange">
                <el-option v-for="item in togSubTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <!-- <span class="ml20" style="color: red;">提示：添加主体前，请先选择被添加主体在校餐卫士系统中的功能集类型和主体类型！</span>
             -->
             <span class="ml20" style="color: red;">提示：添加主体前，请先选择被添加主体在校餐卫士系统中的主体类型！</span>
          </el-form-item>
           <el-form-item label="功能集配置：" prop="collectionId">
            <el-select class="w200" v-model="transferSelData.collectionId" placeholder="请配置功能集">
                <el-option v-for="item in functionModule" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>  
            <!-- <span class="ml20" style="color: red;">提示：添加主体前，请先选择被添加主体在校餐卫士系统中的功能集类型和主体类型！</span>
             -->
             <span class="ml20" style="color: red;">提示：添加主体前，请先选择被添加主体在校餐卫士系统中的项目集类型！</span>
          </el-form-item>
        </el-form>
        <div v-if="type !== 'TOB'" class="divider"></div>
      </div>
      <div class="addsub-body">
          <div class="left">
              <div class="filtrate">
                  <el-input placeholder="主体名称、负责人、联系方式" class="w300 seekIpt" v-model="leftKeyWord"
                      @keyup.enter.native="leftSearch">
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="leftSearch"></i>
                  </el-input>
                  <el-cascader class="ml20 w300" v-model="leftAreaId" :options="leftAreaList.options"
                      @change="leftAreaChange" :props="type==='TOB'?leftAreaList.props:leftAreaList.togProps" placeholder="所属行政区"
                      ref="leftCascader"></el-cascader>
              </div>
              <el-table v-if="type==='TOB'" height="550" :data="leftData" border style="width: 800px; margin-top: 10px"
                  :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}"
                  v-loading="leftLoading" @selection-change="leftSelectChange" :row-key="getRowKey"
                  ref="leftTable">
                  <el-table-column label="序号" width="80" type="selection" :reserve-selection="true"
                      :selectable="leftSelection">
                  </el-table-column>
                  <el-table-column prop="buyerName" label="主体名称" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.buyerName ? scope.row.buyerName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="areaName" label="所属行政区" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.areaName ? scope.row.areaName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="legalPerson" label="负责人" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.legalPerson ? scope.row.legalPerson: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="tel" label="联系方式" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.tel ? scope.row.tel: '-'}}
                      </template>
                  </el-table-column>
              </el-table>
              <el-table v-else height="550" :data="leftData" border style="width: 800px; margin-top: 10px"
                  :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}"
                  v-loading="leftLoading" @selection-change="leftSelectChange" :row-key="getRowKey"
                  ref="leftTable">
                  <el-table-column label="序号" width="80" type="selection" :reserve-selection="true"
                      :selectable="leftSelection">
                  </el-table-column>
                  <el-table-column prop="entityName" label="主体名称" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.entityName ? scope.row.entityName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="areaName" label="所属行政区" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.areaName ? scope.row.areaName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="corpName" label="负责人" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.corpName ? scope.row.corpName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="mobile" label="联系方式" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.mobile ? scope.row.mobile: '-'}}
                      </template>
                  </el-table-column>
              </el-table>
              <ybPagination :page="leftPage" @size-change="leftPageSizeChange"
                  @current-change="leftPageCurrentChange" style="margin-top:10px;margin-right:10px">
              </ybPagination>
          </div>
          <div class="move-btn">
              <el-button class="ml10" :disabled="isLeftDisabled" @click="moveSubtoRight" type="primary">移入右侧<i
                      class="el-icon-d-arrow-right el-icon--right"></i></el-button>
              <el-button class="mt20" :disabled="isRightDisabled" @click="moveSubtoLeft" type="primary"
                  icon="el-icon-d-arrow-left">移入左侧</el-button>
          </div>
          <div class="right ml10">
              <div class="filtrate">
                  <el-input placeholder="主体名称、负责人、联系方式" class="w300 seekIpt" v-model="rightKeyWord"
                      @keyup.enter.native="rightSearch">
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="rightSearch"></i>
                  </el-input>
                  <el-cascader class="ml20 w300" v-model="rightAreaId" :options="rightAreaList.options"
                      @change="rightAreaChange" :props="type==='TOB'?rightAreaList.props:rightAreaList.togProps" clearable placeholder="所属行政区"
                      ref="rightCascader"></el-cascader>
              </div>
              <el-table v-if="type === 'TOB'" height="550" :data="rightData" border style="width: 800px; margin-top: 10px"
                  :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}"
                  v-loading="rightLoading" @selection-change="rightSelectChange" :row-key="getRowKey"
                  ref="rightTable">
                  <el-table-column label="序号" width="80" type="selection" :reserve-selection="true">
                  </el-table-column>
                  <el-table-column prop="buyerName" label="主体名称" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.buyerName ? scope.row.buyerName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="areaName" label="所属行政区" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.areaName ? scope.row.areaName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="legalPerson" label="负责人" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.legalPerson ? scope.row.legalPerson: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="tel" label="联系方式" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.tel ? scope.row.tel: '-'}}
                      </template>
                  </el-table-column>
              </el-table>
              <el-table v-else height="550" :data="rightData" border style="width: 800px; margin-top: 10px"
                  :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}"
                  v-loading="rightLoading" @selection-change="rightSelectChange" :row-key="getRowKey"
                  ref="rightTable">
                  <el-table-column label="序号" width="80" type="selection" :reserve-selection="true">
                  </el-table-column>
                  <el-table-column prop="entityName" label="主体名称" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.entityName ? scope.row.entityName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="areaName" label="所属行政区" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.areaName ? scope.row.areaName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="corpName" label="负责人" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.corpName ? scope.row.corpName: '-'}}
                      </template>
                  </el-table-column>
                  <el-table-column prop="mobile" label="联系方式" min-width="100" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row.mobile ? scope.row.mobile: '-'}}
                      </template>
                  </el-table-column>
              </el-table>
              <ybPagination :page="rightPage" @size-change="rightPageSizeChange"
                  @current-change="rightPageCurrentChange" style="margin-top:10px;margin-right:10px">
              </ybPagination>
          </div>
      </div>
      <div class="mt20" style="color: red;">提示：点击保存按钮，即批量从{{type === "CFDA" ? "三小" : type}}系统添加主体，并同步{{type === "CFDA" ? "三小" : type}}主体的摄像头配置，已绑定子食堂的摄像头将会被重置解绑，请谨慎操作！</div>
      <div class="footer">
          <el-button @click="addSubCancle" round>关闭</el-button>
          <el-button type="primary" @click="addSubSubmit('transferSel')" round>保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as subManageApi from '@/api/subManage';
import * as moduleApi from '@/api/module';
import ybPagination from '@/components/ybPagination';
import * as mapping from '@/utils/enumList';
import { findBaseUrl } from '@/api/food';
export default {
  components: {
    ybPagination
  },
  props: {
    transferDialogVisible: {
      required: true,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    type: {
      required: true,
      type: String
    }
  },
  computed: {
    togSysDisabled() {
      return this.transferSelData.togSystem && this.isTrueTree ? true : false
    },
    leftTobParams() {
        return {
            areaId: this.leftAreaList.selOptions[this.leftAreaList.selOptions.length - 1],
            current: this.leftPage.pageNum,
            keyword: this.leftKeyWord,
            size: this.leftPage.pageSize
        }
    },
    leftTogParams() {
        return {
            areaCode: this.leftAreaList.selOptions[this.leftAreaList.selOptions.length - 1],
            current: this.leftPage.pageNum,
            keyWord: this.leftKeyWord,
            size: this.leftPage.pageSize,
            appId: this.transferSelData.togSystem
        }
    },
    isLeftDisabled() {
        return this.leftMultipleSelection.length > 0 ? false : true
    },
    isRightDisabled() {
        return this.rightMultipleSelection.length > 0 ? false : true
    },
    // 右表是否有筛选条件
    isRightFilter() {
        return this.rightKeyWord.length > 0 || this.rightAreaList.selOptions.length > 0
    },
  },
  data() {
    return {
      dataRules: {
        togSystem: [{ required: true, message: '请选择TOG环境', trigger: 'change' }], 
        togSubType: [{ required: true, message: '请选择主体类型', trigger: 'change' }],
        collectionId: [{ required: true, message: '请配置功能集', trigger: 'change' }]
      },
      transferSelData: {
        togSystem: '',
        togSubType: '',
        funcCollection: ''
      },
      togSystems: [],
      functionModule:[],
      togSubTypes: mapping.getKeyVal('togSubType'),
      funcCollections: [],
      isTrueTree: true, // 是否成功返回区域树
      leftKeyWord: '',
      leftParentId: '0',
      leftAreaId: '',
      leftAreaList: {
          selOptions: [],
          options: [],
          parentCode: '',
          props: {
              checkStrictly: true,
              expandTrigger: 'hover',
              value: 'areaId',
              label: 'areaName',
              children: 'children',
              lazy: true,
              lazyLoad(node, resolve) {}
          },
          togProps: {
              checkStrictly: true,
              expandTrigger: 'hover',
              value: 'areaCode',
              label: 'areaName',
              children: 'children'
          }
      },
      leftData: [],
      leftLoading: false,
      leftIds: [],
      leftMultipleSelection: [],
      leftPage: {
          pageSize: 10,
          pageNum: 1,
          total: 0
      },

      rightKeyWord: '',
      rightParentId: '0',
      rightAreaId: '',
      rightAreaList: {
          selOptions: [],
          options: [],
          parentCode: '',
          props: {
              checkStrictly: true,
              expandTrigger: 'hover',
              value: 'areaId',
              label: 'areaName',
              children: 'children',
              lazy: true,
              lazyLoad(node, resolve) {}
          },
          togProps: {
              checkStrictly: true,
              expandTrigger: 'hover',
              value: 'areaCode',
              label: 'areaName',
              children: 'children'
          }
      },
      rightData: [], // 右表当前页数据
      rightTotalData: [], // 右表全数据
      rightFilterData: [], // 右表条件筛选数据
      rightLoading: false,
      rightIds: [],
      rightMultipleSelection: [],
      rightPage: {
          pageSize: 10,
          pageNum: 1,
          total: 0
      },
      delIds: []
    }
  },
  methods: {
    clearParams() {
        this.leftKeyWord = ''
        this.leftParentId = '0'
        this.leftAreaId = ''
        this.leftIds = []
        this.leftMultipleSelection = []
        this.leftData = []
        this.leftPage = {
            pageNum: 1,
            pageSize: 10,
            total: 0
        }
        this.rightKeyWord = ''
        this.rightParentId = '0'
        this.rightAreaId = ''
        this.rightIds = []
        this.rightMultipleSelection = []
        this.rightData = []
        this.rightPage = {
            pageNum: 1,
            pageSize: 10,
            total: 0
        }
        this.rightTotalData = []
        this.rightFilterData = []
    },
    initTobData() {
        this.clearParams()
        let that = this;
        that.leftAreaList.props.lazyLoad = function (node, resolve) {
            let code = node.value ? node.value : that.leftParentId;
            if (code.length > 6) {
                return resolve([])
            }
            subManageApi.getAreaList({ parentId: code }).then(r => {
                if (r.code === 200) {
                    resolve(r.data)
                }
            });
        }
        this.leftTableRefresh()
        that.rightAreaList.props.lazyLoad = function (node, resolve) {
            let code = node.value ? node.value : that.rightParentId;
            if (code.length > 6) {
                return resolve([])
            }
            subManageApi.getAreaList({
                parentId: code
            }).then(r => {
                if (r.code === 200) {
                    resolve(r.data)
                }
            });
        }
        this.rightTableRefresh()
    },
    initTogData() {
        this.clearParams()
        this.getTogSystemList()
    },
    // tog系统下拉列表
    getTogSystemList() {
      subManageApi.togSysList().then(res => {
        if(res.code === 200) {
          this.togSystems = res.data
        }
      }).catch(err => {})
    },
    // tog系统选择
    togSystemChange(val) {
      this.getTogAreaTree()
    },
    // 主体类型选择
    togSubTypeChange(val) {

    },
    // 根据tog系统返回区域树
    getTogAreaTree() {
      subManageApi.togAreaTree({appId: this.transferSelData.togSystem}).then(res => {
        if(res.code === 200) {
          this.isTrueTree = true
          this.leftAreaList.options = res.data.children
          this.rightAreaList.options = res.data.children
        } else {
          this.isTrueTree = false
        }
        // else {
        //   let obj = {}
        //   obj.stopPropagation = () =>{}
        //   try{
        //     this.$refs.leftCascader.clearValue(obj)
        //     this.$refs.rightCascader.clearValue(obj)
        //   }catch(err){
        //     this.$refs.leftCascader.handleClear(obj)
        //     this.$refs.rightCascader.handleClear(obj)
        //   }
        //   this.leftAreaList.options = []
        //   this.rightAreaList.options = []
        // }
      }).catch(err => {})
    },
    // tog区域树选择
    leftAreaChange(val) {
      // this.getTogList()
      this.leftTableRefresh();
    },
    addSubCancle() {
        this.handleCloseDialog();
    },
    handleCloseDialog() {
        this.$emit('closeTransferDialog');
    },
    addSubSubmit(transferSel) {
        // this.rightTotalData 右边全部数据
      this.$refs[transferSel].validate((valid) => {
        if (!valid) return
        if(this.type === 'TOB') {
          let ids = []
          this.rightTotalData.forEach(item => {
              ids.push(item.id)
          })
          subManageApi.tobSubBatchAdd({ids:ids,collectionId:this.transferSelData.collectionId}).then(res => {
            if (res.code === 200) {
              this.$message.success('添加成功')
              this.handleCloseDialog()
              this.$parent.tableRefresh()
            }
          })
        } else {
          let entities = []
          this.rightTotalData.forEach(item => {
            entities.push(item)
          })
          let addTogParmas = {
            appId: this.transferSelData.togSystem,
            areaCode: this.leftAreaId[this.leftAreaId.length - 1],
            buyerType: this.transferSelData.togSubType,
            entities: entities,
            collectionId:this.transferSelData.collectionId
          }
          subManageApi.togSubBatchAdd(addTogParmas).then(res => {
            if (res.code === 200) {
              this.$parent.tableRefresh()
              this.handleCloseDialog()
              this.$confirm(`本次添加成功${res.data.successCount}个，失败${res.data.errorCount}个! ${res.data.errorCount>0 ? '是否下载失败记录？' : ''}`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                  if(res.data.errorCount == 0)
                  return
                  findBaseUrl().then(r => {
                    if(r.code === 200) {
                      let url = r.data.baseUrl + '/' + res.data.fileUrl
                      window.location.href = `/api/guard/common/file/download?fileUrl=${url}`
                    }
                  })
              }).catch(e => {});
            } 
          })
        }
      })
    },
    getRowKey(row) {
        return this.type === 'TOB' ? row.id : row.entityId
    },

    leftSearch() {
        this.leftPage.pageNum = 1
        this.leftTableRefresh()
    },
    leftAreaChange(val) {
        this.leftPage.pageNum = 1
        this.leftAreaList.selOptions = val
        this.leftTableRefresh()
    },
    leftSelectChange(val) {
        this.leftMultipleSelection = val;
        this.leftIds = []
        if (val) {
            if(this.type === 'TOB') {
              val.forEach(item => {
                if (item) {
                      this.leftIds.push(item.id)
                  }
              })
            } else {
              val.forEach(item => {
                if (item) {
                      this.leftIds.push(item.entityId)
                  }
              })
            }
        }
    },
    leftSelection(row, index) {
        if (!this.rightIds.length) {
            return true
        } else {
            if(this.type === 'TOB') {
              if(this.rightIds.some((item) => {
                    return row.id === item
                })) {
                return false;
              } else {
                  return true;
              }
            } else {
              if(this.rightIds.some((item) => {
                    return row.entityId === item
                })) {
                return false;
              } else {
                  return true;
              }
            }
        }
    },
    leftPageSizeChange(size) {
        if (size !== this.leftPage.pageSize) {
            this.leftPage.pageNum = 1;
            this.leftPage.pageSize = size;
            this.leftTableRefresh();
        }
    },
    leftPageCurrentChange(num) {
        if (num !== this.leftPage.pageNum) {
            this.leftPage.pageNum = num;
            this.leftTableRefresh();
        }
    },
    leftTableRefresh() {
        this.leftLoading = true;
        if(this.type === 'TOB') {
          subManageApi.tobExpectBindSub(this.leftTobParams).then(r => {
            if (r.code === 200) {
                this.leftData = r.data.records
                this.leftPage.total = parseInt(r.data.total)
            }
            this.leftLoading = false;
          }).catch(err => {})
        } else if(this.type === 'TOG') {
          subManageApi.getSubOfTogEntity(this.leftTogParams).then(r => {
            if (r.status) {
                this.leftData = r.data.list
                this.leftPage.total = parseInt(r.data.total)
            }
            this.leftLoading = false;
          }).catch(err => {})
        } else {
          subManageApi.getCfdaOfTogEntity(this.leftTogParams).then(r => {
            if (r.status) {
                this.leftData = r.data.list
                this.leftPage.total = parseInt(r.data.total)
            }
            this.leftLoading = false;
          }).catch(err => {})
        }
    },

    moveSubtoRight() {
        if (this.isRightFilter) { // 有筛选条件
            for (let i = 0; i < this.leftMultipleSelection.length; i++) {
                this.rightFilterData.push(this.leftMultipleSelection[i])
            }
        } else { // 无筛选
            for (let i = 0; i < this.leftMultipleSelection.length; i++) {
                this.rightTotalData.push(this.leftMultipleSelection[i])
            }
        }
        this.rightTableRefresh()
        for (let i = 0; i < this.leftIds.length; i++) {
            this.rightIds.push(this.leftIds[i])
        }
        this.$refs.leftTable.clearSelection();
    },
    moveSubtoLeft() {
        this.rightIds = this.rightIds.filter((item) => {
            return this.delIds.indexOf(item) == -1
        })
        
        if(this.type === 'TOB') {
          this.isRightFilter ? this.rightFilterData 
                           : this.rightTotalData 
                           = this.rightTotalData.filter((item) => {
                              return this.delIds.indexOf(item.id) == -1
                             })
        } else {
          this.isRightFilter ? this.rightFilterData 
                           : this.rightTotalData 
                           = this.rightTotalData.filter((item) => {
                              return this.delIds.indexOf(item.entityId) == -1
                             })
        }
        
        this.rightTableRefresh()
        this.$refs.rightTable.clearSelection();
        if (this.rightData.length == 0) {
            this.rightPage.pageNum = 1
        }
        this.rightTableRefresh()
    },

    rightSearch() {
        // 右表搜索, 过滤出三个对应字段包含搜索值的data
        this.rightPage.pageNum = 1
        if(this.type === 'TOB') {
          this.rightFilterData = this.rightTotalData.filter(item => {
              return item.buyerName.indexOf(this.rightKeyWord) != -1 ||
                  item.legalPerson.indexOf(this.rightKeyWord) != -1 ||
                  item.tel.indexOf(this.rightKeyWord) != -1
          })
        } else {  
          this.rightFilterData = this.rightTotalData.filter(item => {
              return item.entityName.indexOf(this.rightKeyWord) != -1 ||
                  item.corpName.indexOf(this.rightKeyWord) != -1 ||
                  item.mobile.indexOf(this.rightKeyWord) != -1
          })
        }
        this.rightTableRefresh()
    },
    rightAreaChange(val) {
        // 右表区域筛选
        this.rightAreaList.selOptions = val
        this.rightPage.pageNum = 1
        if(this.type === 'TOB') {
          this.rightFilterData = this.rightTotalData.filter(item => {
            if(val.length === 0) { // 未选择区域
              return item
            }
            if(val.length === 1) { // 选中省级 或 直辖市
              if(item.areaId.slice(0,2) === val[0].slice(0,2)) {
                return item
              }
            }
            if(val.length === 2) { // 选中市 或 直辖市下的区
              if(val[1].slice(4,6) === '00') { // 选中市
                if(item.areaId.slice(0,4) === val[1].slice(0,4)) {
                  return item
                }
              } else {
                if(item.areaId.slice(0,6) === val[1].slice(0,6)) {
                  return item
                }
              }
            }
            if(val.length === 3) { // 选中区
              if(item.areaId.slice(0,6) === val[2].slice(0,6)) {
                return item
              }
            }
            if(val.length === 4) { // 选中街道
              if(item.areaId === val[3]) {
                return item
              }
            }
          })
        } else {
          let areaCodeArr = []
          // TOG areaCode 格式为 "51", "5101"..., 补足0到六位方便筛选
          if(val.length > 0) {
            val.forEach(areaItem => {
              if(areaItem.length === 2) {
                areaItem += '0000'
              } else if(areaItem.length === 4) {
                areaItem += '00'
              }
              areaCodeArr.push(areaItem)
            })
          }
          this.rightFilterData = this.rightTotalData.filter(item => {
            
            if(areaCodeArr.length === 0) { // 未选择区域
              return item
            }
            if(areaCodeArr.length === 1) { // 选中省级 或 直辖市
              if(item.areaCode.slice(0,2) === areaCodeArr[0].slice(0,2)) {
                return item
              }
            }
            if(areaCodeArr.length === 2) { // 选中市 或 直辖市下的区
              if(areaCodeArr[1].slice(4,6) === '00') { // 选中市
                if(item.areaCode.slice(0,4) === areaCodeArr[1].slice(0,4)) {
                  return item
                }
              } else {
                if(item.areaCode.slice(0,6) === areaCodeArr[1].slice(0,6)) {
                  return item
                }
              }
            }
            if(areaCodeArr.length === 3) { // 选中区
              if(item.areaCode.slice(0,6) === areaCodeArr[2].slice(0,6)) {
                return item
              }
            }
            if(areaCodeArr.length === 4) { // 选中街道
              if(item.areaCode === areaCodeArr[3]) {
                return item
              }
            }
          })
        }
        this.rightTableRefresh()
    },
    rightSelectChange(val) {
        this.rightMultipleSelection = val;
        this.delIds = []
        if (val) {
          if(this.type === 'TOB') {
            val.forEach(item => {
                if (item) {
                    this.delIds.push(item.id)
                }
            })
          } else {
            val.forEach(item => {
                if (item) {
                    this.delIds.push(item.entityId)
                }
            })
          }
        }
    },
    rightPageSizeChange(size) {
        if (size !== this.rightPage.pageSize) {
            this.rightPage.pageNum = 1;
            this.rightPage.pageSize = size;
            this.rightTableRefresh();
        }
    },
    rightPageCurrentChange(num) {
        if (num !== this.rightPage.pageNum) {
            this.rightPage.pageNum = num;
            this.rightTableRefresh();
        }
    },
    rightTableRefresh() {
        this.rightLoading = true
        this.rightData = []
        let lastPageDataNum = (this.rightPage.pageNum - 1) * this.rightPage.pageSize
        let currentPageDataNum = this.rightPage.pageNum * this.rightPage.pageSize
        // 右表, 有筛选条件时, 数据显示rightFilterData(筛选后的数据); 无筛选时, 数据显示rightTotalData(全部数据)
        if (this.isRightFilter) { // 有筛选条件
            if (currentPageDataNum <= this.rightFilterData.length) {
                for (let i = lastPageDataNum; i < currentPageDataNum; i++) {
                    this.rightData.push(this.rightFilterData[i])
                }
            } else {
                let remainingDataNum = this.rightFilterData.length - lastPageDataNum
                for (let i = lastPageDataNum; i < remainingDataNum+lastPageDataNum; i++) {
                    this.rightData.push(this.rightFilterData[i])
                }
            }
            this.rightPage.total = this.rightFilterData.length
        } else { // 筛选条件为空
            if (currentPageDataNum <= this.rightTotalData.length) { // 页面size填满
                for (let i = lastPageDataNum; i < currentPageDataNum; i++) {
                    this.rightData.push(this.rightTotalData[i])
                }
            } else { // 页面size未满
                let remainingDataNum = this.rightTotalData.length - lastPageDataNum // 末页余下的data条数
                for (let i = lastPageDataNum; i < remainingDataNum+lastPageDataNum; i++) {
                    this.rightData.push(this.rightTotalData[i])
                }
            }
            this.rightPage.total = this.rightTotalData.length
        }
        this.rightLoading = false
    },
    async getFunctionList(){
      let result = await moduleApi.getFunctionList()
      this.functionModule = result.data
    }
  },
  mounted() {
    if(this.type === "TOB") {
      this.initTobData()
    } else {
      this.initTogData()
    }
    this.getFunctionList()
  }
}
</script>

<style scoped lang="scss">
  .addsub-dialog::v-deep .el-dialog {
        width: 1800px;

        .addsub-body {
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: flex-start;
            .move-btn {
                align-self: center;
                // padding-top: 240px;
                .el-button {
                    display: block;
                    font-size: 16px;
                    font-weight: 700;
                }
            }

            .el-table {
                max-height: 550px;
                overflow-y: auto;
            }
        }
    }
    .divider {
      width: 100%;
      margin: 20px;
      border-bottom: 1px solid #606266;
      margin-left: 50%;
      transform: translate(-50%);
    }
    .footer {
        margin-top: 20px;
        text-align: right;
    }
    .el-form .el-form-item {
      margin-bottom: 20px;
      margin-right: 100px;
    }

</style>